import { instance as axios, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance"

// ---------------------fatch-community-listing--------------------------
export const getuserListApi = async (data) => {
    const endPoint = `/user/list` + '?' + new URLSearchParams({ ...data, }).toString()
    return await axios.get(endPoint, setJwtToken())
}

// ---------------------fatch-community-listing--------------------------
export const getUserDetailsApi = async (id) => {
    const endPoint = `/user/details/${id}`
    return await axios.get(endPoint, setJwtToken())
}
// ---------------------change-status-user---------------------------
export const changeUserStatusApi = async (data) => {
    const endPoint = `/user/change_status`
    return await axios.put(endPoint, data, setJwtToken())
}

// ---------------------communty-list--------who-user-create--------------------------
export const communityListUserApi = async (id) => {
    const endPoint = `/user/my_community_list` + `?` + new URLSearchParams({ ...id }).toString()
    return await axios.get(endPoint, setJwtToken())
}

